<template>
  <div class="row justify-content-center my-5">
    <div class="col-sm-11 col-md-10 col-lg-8">
      <div class="campaign">
        <!-- <div class="campaign-header">
          <h1>Amazonギフト券1,000円分が貰えるかも！？</h1>
          <p>
            公式アカウントフォロー＆診断結果
            <span class="d-inline-block">シェアキャンペーン</span>
            <a
              class="d-inline-block"
              href="https://netsagisoken.jp/lp/quiz-cp/"
              target="_blank"
            >詳細はこちら</a>
          </p>
        </div>-->
        <div class="campaign-content">
          <social-sharing
            :url="twitterUrl"
            :title="twitterText"
            hashtags="こぶたの夢のマイホーム,ネットセキュリティ診断"
            inline-template
          >
            <network network="twitter">
              <b-button @click="$emit('set')" class="btn-click my-3">
                Twitterにシェア
                <font-awesome-icon icon="arrow-circle-right" />
              </b-button>
            </network>
          </social-sharing>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "quiz-campaign",
  props: ["results_array"],
  computed: {
    twitterUrl: function() {
      return (
        "https://netsagisoken.jp/lp/quiz/result/" +
        this.results_array.resultpage
      );
    },
    twitterText: function() {
      return (
        "あなたのセキュリティレベルは…【" +
        this.results_array.text +
        "】！みんなもネットセキュリティの知識レベルをチェックしてみよう！"
      );
    }
  }
};
</script>


<style lang="scss">
.campaign {
  background: #fff;
  border: 2px solid #ff4e00;
  .campaign-header {
    padding: 1rem;
    text-align: left;
    background-color: rgba(255, 255, 255, 0);
    background-image: -webkit-gradient(
      linear,
      0 0,
      100% 100%,
      color-stop(0.25, #ffe6d1),
      color-stop(0.25, transparent),
      color-stop(0.5, transparent),
      color-stop(0.5, #ffe6d1),
      color-stop(0.75, #ffe6d1),
      color-stop(0.75, transparent),
      to(transparent)
    );
    background-size: 7px 7px;
    h1 {
      font-size: 100%;
      font-weight: 900;
    }
    p {
      @media (min-width: 420px) {
        padding-right: 120px;
      }
    }
    h1,
    p {
      margin: 0.2rem 0;
      color: #ff3c00;
    }
    a {
      color: #ff3c00;
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
  }
  .campaign-content {
    text-align: center;
    padding: 1rem 0 0;
    position: relative;
    .btn-click {
      color: #fff;
    }
    @media (min-width: 576px) {
      padding: 1rem;
      text-align: left;
    }
    &:after {
      content: "";
      display: block;
      width: 100%;
      height: 100px;
      background: url(../static/start_bu.svg) no-repeat bottom center;
      background-size: contain;
      pointer-events: none;
      @media (min-width: 576px) {
        position: absolute;
        bottom: 0;
        right: 15px;
        height: 100%;
        background-position: bottom right;
      }
    }
  }
  .btn-click {
    margin: 0 1rem;
    background: rgba(29, 161, 242, 1);
    text-decoration: none;
    &:hover {
      background: rgba(29, 161, 242, 0.8);
    }
  }
  h1,
  p,
  .btn-click {
    text-shadow: 0 0 1px #fff;
    position: relative;
    z-index: 10;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/QuizCampaign.vue